import {useQuery} from '@tanstack/react-query';
import {useReservation} from 'context/reservation';
import {useSummary} from 'context/summary';
import {Contract,QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';

function useContracts() {
  const {housing} = useReservation();
  const {data: summary} = useSummary();

  const housingId = housing?.id;
  const isContractEnabled = summary?.is_contract_enabled;

  const {data, error, isLoading} = useQuery<Contract[], Error>({
    queryKey: [QUERY_CACHE_KEYS.contracts, housingId],
    queryFn: () => API.documents.getContracts(`housing_sample_id=${housingId}`),
    enabled: Boolean(isContractEnabled && housingId),
    refetchOnWindowFocus: false,
  });

  return {
    isLoadingContracts: Boolean(isContractEnabled && housingId) && isLoading,
    isContractsError: !!error,
    contracts: data,
  };
}

export {useContracts};
